import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { forcyteService } from '@/services'
import { ROUTES } from '@/constants'

export const PublicRoute = () => {
  const hasToken = forcyteService.getToken()

  if (hasToken) return <Navigate to={ROUTES.HOME} replace />

  return <Outlet />
}
